import { Planzone, Identifiable, Unavailability } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function saveUnavailability(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, unavailability: Unavailability) =>
    httpClient
      .sendHttpRequest<Identifiable<Unavailability>>({
        endpoint: `/unavailabilities`,
        method: HttpMethods.POST,
        data: {
          ...unavailability,
          ...(unavailability.startDate && {
            startDate: formatDate(unavailability.startDate),
          }),
          ...(unavailability.endDate && {
            endDate: formatDate(unavailability.endDate),
          }),
          resource: `resources/${unavailability.resource.uuid}`,
          planzone: `planzones/${planzone.uuid}`,
          reason: `unavailabilityReasons/${unavailability.reason.uuid}`,
        },
      })
      .then((savedUnavailability) => ({
        ...unavailability,
        ...savedUnavailability,
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            invalidUnavailabilityNonWorkedHoursCount:
              "invalidUnavailabilityNonWorkedHoursCount",
            invalidUnavailabilityDates: "invalidUnavailabilityDates",
          }),
        ),
      );
}
export { saveUnavailability };
